
import './App.css';
import ChartComponent from './Charts'

function App() {
  return (
    <div className="App">
     <ChartComponent/>
    </div>
  );
}

export default App;
